module.exports = __webpack_public_path__ + "static/img/logo.a699d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 9